module.exports = __webpack_public_path__ + "images/ticket-master-aae063a69087d58b84e2a46d409a6142.png";